import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogContentText, Modal, ModalProps } from '@p81-common/ui';

interface CancellationModalProps {
  open: ModalProps['open'];
  handleCancelClick: (event?: React.MouseEvent) => void;
  handleCloseClick: (event?: React.MouseEvent) => void;
}

const CancellationModal = ({
  open,
  handleCancelClick,
  handleCloseClick
}: CancellationModalProps) => {
  const { t } = useTranslation(['activity']);

  return (
    <Modal
      id="cancelModal"
      open={open}
      dialogActionsProps={{
        children: (
          <>
            <Button variant="text" color="primary" onClick={handleCloseClick}>
              {t('activity:buttons.DISMISS')}
            </Button>
            <Button color="primary" onClick={handleCancelClick}>
              {t('activity:buttons.CANCEL')}
            </Button>
          </>
        )
      }}
      dialogContentProps={{
        children: (
          <DialogContentText>
            {t('activity:networkRollout.CANCELLATION_MODAL_CONTENT')}
          </DialogContentText>
        )
      }}
      dialogTitleProps={{
        children: t('activity:networkRollout.CANCELLATION_MODAL_TITLE')
      }}
      onClose={handleCloseClick}
    />
  );
};

export default CancellationModal;
